import { filterString } from './cleanup'

export const currencyStringToFloat = (value) => {
  const finalValue = parseFloat(filterString(value, ['R', '$', '.']).replace(',', '.'))
  return isNaN(finalValue) ? 0 : finalValue
}

export const currencyFloatToString = (value) => {
  if (value != null) {
    return 'R$ ' + value.toFixed(2).replace('.', ',')
  }
  return 'R$ 0,00'
}
